import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizRow, WizCol } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'
import Criteria from '../../components/criteria'
import AcceptanceResults from '../../components/acceptanceResults'
import Result from '../../components/result'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/preAuditProcess/result/send') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('preAuditResultSend', record)
        } else {
            record = Session.get('preAuditResultSend') || {}
        }
    }
    return record
}

class PreAuditResultSend extends WizContainer {

    componentName = 'PreAuditResultSend'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId } = this.state.record
        this.doActions([{
            path: 'counselingProcess/acceptanceResults',
            payload: {
                key: 'preAuditAcceptanceResults@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        }, {
            path: 'counselingProcess/evaluationCriteria',
            payload: {
                key: 'preAuditEvaluationCriteriaSend@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        }])
    }

    _onSub = (values) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/sendPreAuditOrCheck',
            payload: {
                key: 'sendPreAuditResult@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1,
                    ...values
                }
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    render() {
        let { record } = this.state
        let { auditAcceptanceResults, evaluationCriteria, counselingProcessLoading } = this.props
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <AcceptanceResults data={auditAcceptanceResults.data} title='预审核验收结果' type='send' />
                <Criteria data={evaluationCriteria.data} title='预审核标准' type='send' />
                <Result title='预审核结果' type='send' onSub={this._onSub} />
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const evaluationCriteria = modelUtils.getModelEntity(counselingProcess, 'preAuditEvaluationCriteriaSend@' + processContentId)
    const auditAcceptanceResults = modelUtils.getModelEntity(counselingProcess, 'preAuditAcceptanceResults@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'sendPreAuditResult@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        evaluationCriteria,
        auditAcceptanceResults,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(PreAuditResultSend)


